// src/context/CartContext.js — FIXED (adds removeItem)
import React, { createContext, useContext, useReducer } from 'react';

const CartContext = createContext(null);
const TAX_RATE = 0.05;

const cartReducer = (state, action) => {
  switch (action.type) {
    case 'ADD': {
      const existing = state.find((i) => i.id === action.item.id);
      if (existing) return state.map((i) => i.id === action.item.id ? { ...i, qty: i.qty + 1 } : i);
      return [...state, { ...action.item, qty: 1 }];
    }
    case 'REMOVE':
      return state.filter((i) => i.id !== action.id);
    case 'SET_QTY':
      if (action.qty <= 0) return state.filter((i) => i.id !== action.id);
      return state.map((i) => i.id === action.id ? { ...i, qty: action.qty } : i);
    case 'CLEAR':
      return [];
    default:
      return state;
  }
};

export const CartProvider = ({ children }) => {
  const [cart, dispatch] = useReducer(cartReducer, []);

  const subtotal = cart.reduce((s, i) => s + i.price * i.qty, 0);
  const tax      = parseFloat((subtotal * TAX_RATE).toFixed(2));
  const total    = parseFloat((subtotal + tax).toFixed(2));

  return (
    <CartContext.Provider value={{
      cart,
      subtotal, tax, total,
      addItem:    (item) => dispatch({ type: 'ADD', item }),
      removeItem: (id)   => dispatch({ type: 'REMOVE', id }),   // ← ensure exported
      setQty:     (id, qty) => dispatch({ type: 'SET_QTY', id, qty }),
      clearCart:  ()     => dispatch({ type: 'CLEAR' }),
    }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
